import React, { memo } from 'react'
import PropTypes from 'prop-types'

// Api
import { downloadTicketCommentAttachment } from 'api/ticket-comment'

// Helpers
import { resolveErrorMessage } from 'helpers'

// Services
import message from 'services/message'

// Components
import FileItem from 'ui/FileItem'
import Row from 'ui/Row'
import Col from 'ui/Col'

export const TicketCommentAttachments = memo(({ files, commentId }) => {
  // Events
  const onDownloadFileComment = async (fileName, setLoading) => {
    try {
      setLoading(true)

      await downloadTicketCommentAttachment({ fileName, commentId })
    } catch (error) {
      message.error(await resolveErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  if (files.length) {
    return (
      <Row>
        <Col xs={12} sm={6} md={5}>
          {files.map((file, index) => (
            <FileItem
              key={index}
              name={file.name}
              status={file.status}
              onDownload={onDownloadFileComment}
            />
          ))}
        </Col>
      </Row>
    )
  }

  return null
})

TicketCommentAttachments.displayName = 'TicketCommentAttachments'

TicketCommentAttachments.propTypes = {
  commentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  files: PropTypes.array,
}

TicketCommentAttachments.defaultProps = {
  commentId: '',
  files: [],
}

export default TicketCommentAttachments
